/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout'

const epidemicControl = {
  path: '/epidemic-control',
  component: Layout,
  redirect: '/epidemic-control',
  name: 'EpidemicControl',
  meta: {
    title: 'epidemicControl',
    icon: 'zijinrizhi',
    perm: 'cSiteEpp'
  },
  children: [
    {
      path: 'project-person',
      component: () => import('@/views/epidemic-control/project-person/index.vue'),
      name: 'ProjectPerson',
      meta: {
        title: 'projectPerson',
        perm: 'cSiteEppPerson'
      }
    },
    {
      path: 'abnormal-people',
      component: () => import('@/views/epidemic-control/abnormal-people/index.vue'),
      name: 'AbnormalPeople',
      meta: {
        title: 'abnormalPeople',
        perm: 'cSiteEppPersonRecordFace'
      }
    },
    {
      path: 'id-card-identification',
      component: () => import('@/views/epidemic-control/id-card-identification/index.vue'),
      name: 'IdCardIdentification',
      meta: {
        title: 'idCardIdentification',
        perm: 'cSiteEppPersonRecordCertificateCard'
      }
    },
    {
      path: 'health-code-identification',
      component: () => import('@/views/epidemic-control/health-code-identification/index.vue'),
      name: 'HealthCodeIdentification',
      meta: {
        title: 'healthCodeIdentification',
        perm: 'cSiteEppPersonRecordQrCode'
      }
    }
  ]
}
export default epidemicControl
